import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import NhStyleFingerprintTableRow from './NhStyleFingerprintTableRow';

function NhStyleFingerprintTableHead() {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Name</TableCell>
        <TableCell>Kind</TableCell>
        <TableCell>Beer count</TableCell>
        <TableCell>Mapped beers</TableCell>
        <TableCell>Eligible or reason</TableCell>
        <TableCell>Distinctive style 1</TableCell>
        <TableCell>Distinctive style 2</TableCell>
        <TableCell>Distinctive style 3</TableCell>
        <TableCell>Top match</TableCell>
      </TableRow>
    </TableHead>
  );
}

function NhStyleFingerprintTable({ identities }) {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <NhStyleFingerprintTableHead />
        <TableBody>
          {identities.map((identity) => (
            <NhStyleFingerprintTableRow key={identity.identityId} identity={identity} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default NhStyleFingerprintTable;
